const sub32 = (a, b) => (a - b) | 0;
export default sub32;
